import Emitter from 'tiny-emitter'

const emitter = new Emitter()

export default emitter